<template>
  <div v-if="message" class="m3p-form__error">{{ message }}</div>
</template>

<script setup>
import { useFieldError } from 'vee-validate';

const props = defineProps({
  name: {
    type: String,
    required: true
  }
});

const message = useFieldError(props.name);
</script>
